// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TableSkeleton.module.css */

.tableSkeleton_tableContainer__GCBE- {
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
  background-color: white;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.tableSkeleton_table__h9gne {
  width: 100%;
  min-width: 650px;
  border-collapse: collapse;
  table-layout: fixed;
}

.tableSkeleton_tableHead__kqZqd {
  background-color: #f9fafb;
}

.tableSkeleton_tableHeaderCell__Mvx7g {
  padding: 12px 24px;
  text-align: left;
  width: 10%; /* Equal width for 10 columns */
  border-bottom: 1px solid #e5e7eb;
}

.tableSkeleton_tableBody__9ckf0 {
  background-color: white;
}

.tableSkeleton_tableRow__gJTrH {
  transition: background-color 0.15s ease-in-out;
}

.tableSkeleton_tableRow__gJTrH:hover {
  background-color: #f9fafb;
}

.tableSkeleton_tableRow__gJTrH:not(:last-child) {
  border-bottom: 1px solid #e5e7eb;
}

.tableSkeleton_tableCell__5LhZb {
  padding: 16px 24px;
  white-space: nowrap;
  width: 10%; /* Equal width for 10 columns */
}

.tableSkeleton_skeletonBar__OuQkb {
  height: 16px;
  width: 75%;
  background-color: #d1d5db;
  border-radius: 4px;
  animation: tableSkeleton_pulse__Ou8e6 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes tableSkeleton_pulse__Ou8e6 {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}`, "",{"version":3,"sources":["webpack://./src/utils/tableSkeleton.module.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU,EAAE,+BAA+B;EAC3C,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,UAAU,EAAE,+BAA+B;AAC7C;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,8EAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["/* TableSkeleton.module.css */\n\n.tableContainer {\n  width: 100%;\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n  background-color: white;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\n.table {\n  width: 100%;\n  min-width: 650px;\n  border-collapse: collapse;\n  table-layout: fixed;\n}\n\n.tableHead {\n  background-color: #f9fafb;\n}\n\n.tableHeaderCell {\n  padding: 12px 24px;\n  text-align: left;\n  width: 10%; /* Equal width for 10 columns */\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tableBody {\n  background-color: white;\n}\n\n.tableRow {\n  transition: background-color 0.15s ease-in-out;\n}\n\n.tableRow:hover {\n  background-color: #f9fafb;\n}\n\n.tableRow:not(:last-child) {\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.tableCell {\n  padding: 16px 24px;\n  white-space: nowrap;\n  width: 10%; /* Equal width for 10 columns */\n}\n\n.skeletonBar {\n  height: 16px;\n  width: 75%;\n  background-color: #d1d5db;\n  border-radius: 4px;\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableContainer": `tableSkeleton_tableContainer__GCBE-`,
	"table": `tableSkeleton_table__h9gne`,
	"tableHead": `tableSkeleton_tableHead__kqZqd`,
	"tableHeaderCell": `tableSkeleton_tableHeaderCell__Mvx7g`,
	"tableBody": `tableSkeleton_tableBody__9ckf0`,
	"tableRow": `tableSkeleton_tableRow__gJTrH`,
	"tableCell": `tableSkeleton_tableCell__5LhZb`,
	"skeletonBar": `tableSkeleton_skeletonBar__OuQkb`,
	"pulse": `tableSkeleton_pulse__Ou8e6`
};
export default ___CSS_LOADER_EXPORT___;
